module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/border_aside-5af5caebf7519d424815406dcc131cb5.png";